import { PageType } from '@shared/enums';

/**
 * Maps a CMS page-type variant to the base page type whose layout and behaviour it shares.
 *
 * Some CMS page types are variants of an existing type (e.g. the "Contract/pro" realisations:
 * `projects_pro`, `projects_details_pro`) that must render and behave exactly like their base
 * type. This map is the single source of truth: every consumer derives from it (section paddings
 * via the page wrapper class, hero anchors, listing pagination...), so supporting a new variant
 * only requires adding one entry here.
 */
export const pageTypeGroup: Partial<Record<keyof typeof PageType, keyof typeof PageType>> = {
  expertise_pro: 'expertise',
  projects_pro: 'projects',
  projects_details_pro: 'projects_details',
};

/**
 * Returns the base page type for a given type: the mapped base when the type is a registered
 * variant (see {@link pageTypeGroup}), or the type itself otherwise.
 */
export const toBasePageType = (type: keyof typeof PageType): keyof typeof PageType => pageTypeGroup[type] ?? type;
